import makeStyles from '@mui/styles/makeStyles'

export const useHeaderCellStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(2),
    lineHeight: 1,
    borderRightColor: theme.palette.common.white,
    borderRightWidth: '1px',
    borderRightStyle: 'solid',
    fontFamily: theme.typography.h1.fontFamily,
    fontWeight: 'bold',
    fontSize: theme.typography.body1.fontSize
  }
}))

export const useRowStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer',
    minHeight: '45px',
    borderBottom: `1px solid ${theme.colors.main200}`,

    '&:hover': {
      backgroundColor: theme.colors.gray50
    },

    '& td': {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },

  noResults: {
    borderBottom: `1px solid ${theme.colors.main200}`,
    color: theme.colors.gray700,
    fontFamily: theme.corporate.primaryFont,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '20px'
  }
}))

export const useTableContainerStyles = makeStyles({
  root: {
    overflowY: 'hidden'
  }
})
